import { useState, useEffect } from "react";
import { resolveRegionFromCoordinates } from "../utils/region";

const PATH_TO_BACKEND = process.env.REACT_APP_PATH_TO_BACKEND;

// Регион — по адресу сделки (геокодирование координат из UF_ADDRESS_COORDS),
// та же логика, что determineRegion в BackendProductions.js.
// Если авто-регион не определился, вызывающий код может подставить manualRegion.
export const useDealRegion = (dealId) => {
    const [region, setRegion] = useState(null);
    const [manualRegion, setManualRegion] = useState(null);

    useEffect(() => {
        if (!dealId) return;

        const fetchRegionByAddress = async () => {
            try {
                const response = await fetch(`${PATH_TO_BACKEND}/api/address_clientname`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ dealId }),
                });
                const data = await response.json();
                const { latitude, longitude } = data.coordinates || {};
                if (latitude && longitude) {
                    const resolved = await resolveRegionFromCoordinates(latitude, longitude);
                    setRegion(resolved);
                }
            } catch (error) {
                console.error("Ошибка при определении региона по адресу сделки:", error);
            }
        };
        fetchRegionByAddress();
    }, [dealId]);

    return { region, manualRegion, setManualRegion };
};
